import _classCallCheck from '@immobiliare-labs/babel-runtime/helpers/classCallCheck';
import _createClass from '@immobiliare-labs/babel-runtime/helpers/createClass';
import _possibleConstructorReturn from '@immobiliare-labs/babel-runtime/helpers/possibleConstructorReturn';
import _inherits from '@immobiliare-labs/babel-runtime/helpers/inherits';
import { h, Component, render } from 'preact';
import { addClass, removeClass } from '@immobiliare-labs/dom-classlist';
import { addEvent } from '@immobiliare-labs/dom-events';
import _extends from '@immobiliare-labs/babel-runtime/helpers/extends';

var isSupported = function isSupported() {
    return !!document.createElement('div').addEventListener && !!Array.prototype.reduce && //ES5
    !!window.CanvasRenderingContext2D && !!customElements.define;
};

var isLocalTransformSupported = function isLocalTransformSupported() {
    return isSupported() && !!window.HTMLCanvasElement.prototype.toBlob;
}; // &&

function rotate(state) {
    return state && state.rotate || 0;
}

function scale(state) {
    return state && state.scale || 0;
}

function saveRequested(state) {
    return state && state.save;
}

function restoreRequested(state) {
    return state && state.restore;
}

function saveData(state) {
    return state && state.saveData;
}

function saved(state) {
    return state && state.saved;
}

function translate(state) {
    return state && state.translate;
}

function translated(state) {
    return state && state.translate !== undefined;
}

function aspect(state) {
    return state && state.aspect;
}

function changed(state) {
    return !!rotate(state) || !!aspect(state) || scale(state) !== 0;
}

function assign(a, b) {
    var keys = Object.keys(b);
    var i = 0;
    var l = keys.length;

    while (i < l) {
        a[keys[i]] = b[keys[i]];
        i++;
    }

    return a;
}

function updates(source, update) {
    var keys = Object.keys(update);
    var i = 0;
    var l = keys.length;

    while (i < l) {
        if (source[keys[i]] !== update[keys[i]]) {
            return true;
        }

        i++;
    }

    return false;
}

var update = (function (source, update) {
    if (updates(source, update)) {
        return assign(assign({}, source), update);
    }

    return source;
});

function rotateAction(state, value) {
    return update(state, {
        rotate: ((state.rotate || 0) + value) % 360,
        saved: false
    });
}

function aspectAction(state, value) {
    return update(state, {
        aspect: value || false,
        saved: false
    });
}

function translateAction(state, value) {
    return update(state, {
        translate: value,
        saved: false
    });
}

function rotate90Action(state, value) {
    return rotateAction(state, value);
}

function scaleAction(state, value) {
    return update(state, {
        scale: value,
        saved: false
    });
}

function restoreAction() {
    return {
        restore: {},
        saved: false
    };
}

function saveAction(state) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data';

    return update(state, {
        save: { mode: mode },
        saved: false,
        saveRequested: undefined,
        saveData: undefined
    });
}

function saveDoneAction(state, data) {
    return update(state, {
        saved: true,
        saveData: data
    });
}

function createStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var listeners = [];

    return {
        dispatch: dispatch(initialState, listeners),
        onChange: registerListener(listeners)
    };
}

function applyReducer(reducer, callback) {
    return function (state) {
        return callback(reducer(state));
    };
}

function registerListener(listeners) {
    return function (reducer, callback) {
        listeners.push(callback ? applyReducer(reducer, callback) : reducer);

        return function () {
            listeners.splice(listeners.indexOf(callback), 1);
        };
    };
}

function dispatch(initialState, listeners) {
    var state = initialState || {};

    return function (action) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        var nextState = action.apply(null, [state].concat(args));

        if (state !== nextState) {
            listeners.forEach(function (callback) {
                return callback(nextState);
            });
            state = nextState;
        }
    };
}

var StoreProvider = function (_Component) {
    _inherits(StoreProvider, _Component);

    function StoreProvider() {
        _classCallCheck(this, StoreProvider);

        return _possibleConstructorReturn(this, (StoreProvider.__proto__ || Object.getPrototypeOf(StoreProvider)).apply(this, arguments));
    }

    _createClass(StoreProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return { store: this.props.store };
        }
    }, {
        key: 'render',
        value: function render$$1() {
            return this.props.children[0];
        }
    }]);

    return StoreProvider;
}(Component);

var StoreConnector = function (_Component2) {
    _inherits(StoreConnector, _Component2);

    function StoreConnector() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, StoreConnector);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = StoreConnector.__proto__ || Object.getPrototypeOf(StoreConnector)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = _this2.props.reduceState && _this2.props.reduceState(), _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(StoreConnector, [{
        key: 'getStore',
        value: function getStore() {
            return this.context.store;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.reduceState) {
                this.deregister = this.getStore().onChange(this.props.reduceState, this.setState.bind(this));
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.deregister && this.deregister();
        }
    }, {
        key: 'render',
        value: function render$$1() {
            return this.props.children[0]({
                state: this.state,
                dispatch: this.getStore().dispatch
            });
        }
    }]);

    return StoreConnector;
}(Component);

var cssTransform = (function (el, transform) {
    el.style['-webkit-transform'] = transform;
    el.style.transform = transform;
});

var matrix = {
    toTransformArray: function toTransformArray(matrix) {
        return [matrix[0][0], matrix[1][0], matrix[0][1], matrix[1][1], matrix[0][2], matrix[1][2]].map(function (val) {
            return val.toFixed(4);
        });
    },
    translate: function translate(matrix, x, y) {
        return this.multiply(matrix, [[1, 0, x], [0, 1, y], [0, 0, 1]]);
    },
    setTranslate: function setTranslate(matrix, x, y) {
        matrix[0][2] = x;
        matrix[1][2] = y;

        return matrix;
    },
    rotate: function rotate(matrix, rad) {
        return this.multiply(matrix, this.fromRotate(rad));
    },
    rotateAround: function rotateAround(matrix, rad, x, y) {
        var m1 = this.fromTranslate(x, y),
            m2 = this.fromRotate(rad),
            m3 = this.fromTranslate(-x, -y);

        return this.multiply(this.multiply(m1, m2), m3);
    },
    fromRotateAround: function fromRotateAround(rad, x, y) {
        var cos = Math.cos(rad),
            sin = Math.sin(rad);

        return [[cos, -sin, x * (1 - cos) + y * sin], [sin, cos, y * (1 - cos) - x * sin], [0, 0, 1]];
    },
    setRotate: function setRotate(matrix, rad) {
        matrix[0][0] = Math.cos(rad);
        matrix[0][1] = -Math.sin(rad);
        matrix[1][0] = Math.sin(rad);
        matrix[1][1] = Math.cos(rad);

        return matrix;
    },
    scale: function scale(matrix, scaleX, scaleY) {
        if (scaleY === undefined) {
            scaleY = scaleX;
        }

        return this.multiply(matrix, [[scaleX, 0, 0], [0, scaleY, 0], [0, 0, 1]]);
    },
    setScale: function setScale(matrix, scaleX, scaleY) {
        if (scaleY === undefined) {
            scaleY = scaleX;
        }

        matrix[0][0] = scaleX;
        matrix[1][1] = scaleY;

        return matrix;
    },
    add: function add(a, b) {
        if (a.length != b.length || a[0].length != b[0].length) {
            throw "Dimension mismatch in addition. Matrix A size must match Matrix B size";
        }

        var sum = [];
        for (var m = 0; m < a.length; m++) {
            var row = [];
            for (var n = 0; n < a[m].length; n++) {
                row.push(a[m][n] + b[m][n]);
            }

            sum.push(row);
        }

        return sum;
    },
    multiply: function multiply(a, b) {
        if (a[0].length != b.length) {
            throw "Dimension mismatch in multiplication. Matrix A columns (" + a.length + ") must match Matrix B rows (" + b.length + ")";
        }

        var product = [];
        for (var i = 0; i < a.length; i++) {
            var row = [];
            for (var k = 0; k < b.length; k++) {
                var value = 0;

                if (Array.isArray(b[k])) {
                    // Matrice X Matrice
                    for (var j = 0; j < b[k].length; j++) {
                        value += a[i][j] * b[j][k];
                    }

                    row.push(value);
                } else {
                    // Matrice X Vettore
                    if (Array.isArray(row)) {
                        row = 0;
                    }
                    row += a[i][k] * b[k];
                }
            }
            product.push(row);
        }

        return product;
    },
    identity: function identity(size) {
        var matrix = [];
        for (var i = 0; i < size; i++) {
            var row = [];
            for (var j = 0; j < size; j++) {
                row[j] = j === i ? 1 : 0;
            }

            matrix.push(row);
        }

        return matrix;
    },
    fromTranslate: function fromTranslate(x, y) {
        var m = this.identity(3);
        m[0][2] = x;
        m[1][2] = y;

        return m;
    },
    fromScale: function fromScale(x) {
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;

        var m = this.identity(3);
        m[0][0] = x;
        m[1][1] = y;

        return m;
    },
    fromRotate: function fromRotate(rad) {
        return [[Math.cos(rad), -Math.sin(rad), 0], [Math.sin(rad), Math.cos(rad), 0], [0, 0, 1]];
    }
};

var RAD = Math.PI / 180;

function memoize(fn) {
    return function () {
        var args = Array.prototype.slice.call(arguments),
            hash = '',
            i = args.length,
            currentArg = null;
        while (i--) {
            currentArg = args[i];
            hash += currentArg === Object(currentArg) ? JSON.stringify(currentArg) : currentArg;
            fn.memoize || (fn.memoize = {});
        }
        return hash in fn.memoize ? fn.memoize[hash] : fn.memoize[hash] = fn.apply(this, args);
    };
}

var calculateAspectRatio = function calculateAspectRatio(value) {
    return value.split(':').map(function (v) {
        return parseInt(v);
    }).reduce(function (res, v) {
        return res / v;
    });
};

function loadImage(url, onload) {
    var img = new Image();
    img.src = url;
    img.onload = img.onerror = function () {
        return onload(img);
    };
}

var IDENTITY = matrix.toTransformArray(matrix.identity(3));

var computeRotatedSize = memoize(function computeRotatedSize(w, h$$1, rad) {
    var cos = Math.abs(Math.cos(rad)),
        sin = Math.abs(Math.sin(rad)),
        sw = w * cos + h$$1 * sin,
        sh = w * sin + h$$1 * cos;

    return [sw, sh];
});

var rotatePoint = memoize(function rotatePoint(x, y, rad) {
    var cos = Math.cos(rad),
        sin = Math.sin(rad);

    return [x * cos - y * sin, x * sin + y * cos];
});

var getScale = function getScale(w1, h1, w2, h2) {
    return Math.min(w1 / w2, h1 / h2);
};

var preserveAspect = function preserveAspect(viewport, image, aspectRatio) {
    viewport.width = Math.min(viewport.width, viewport.height * aspectRatio, image.height * aspectRatio);
    viewport.height = Math.min(viewport.height, viewport.width / aspectRatio, image.width / aspectRatio);
};

var MIN_SIZE = 300; //px
var VIEWPORT_PERCENTAGE = 0.9;

function clearContext(ctx) {
    ctx.setTransform.apply(ctx, IDENTITY);
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}

function createCanvas(width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    return canvas;
}

function createPreview() {
    var img = document.createElement('div');
    img.className = 'img';

    return img;
}

function resetTransform(t) {
    t.rotate = 0;
    t.translate = [0, 0];
    t.scale = [1, 1];
}

function resetSelection(s) {
    s.top = 0;
    s.left = 0;
    s.height = 1;
    s.width = 1;
}

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function calculateViewportSize(iw, ih, ratio) {
    var originalAspect = iw / ih;

    ratio = ratio || originalAspect;

    var newWidth = originalAspect > ratio ? ih * ratio : iw;
    var newHeight = newWidth / ratio;

    return [newWidth, newHeight];
}

var Editor = function () {
    function Editor(container, wrapper) {
        _classCallCheck(this, Editor);

        this._container = container;
        //Elemento di riferimento per calcolare dimensioni massime
        this._wrapper = wrapper;

        this._canvas = createCanvas(container.offsetWidth, container.offsetHeight);
        this._preview = createPreview();

        this._container.style.position = 'relative';
        this._container.appendChild(this._preview);
        this._container.appendChild(this._canvas);

        this._context = this._canvas.getContext('2d');

        this._selection = {};
        this._viewport = {};
        this._transform = {};

        this.reset();
    }

    _createClass(Editor, [{
        key: 'setScale',
        value: function setScale(scale) {
            this._transform.scale[0] = this._transform.scale[1] = scale;
            this._render();

            return this;
        }
    }, {
        key: 'setSize',
        value: function setSize(w, h$$1) {
            var render$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var _calculateViewportSiz = calculateViewportSize(w, h$$1, this._aspectRatio),
                newW = _calculateViewportSiz[0],
                newH = _calculateViewportSiz[1];

            this._viewport.width = newW;
            this._viewport.height = newH;

            this._onResize(render$$1);

            return this;
        }
    }, {
        key: 'setAspectRatio',
        value: function setAspectRatio(ratio) {
            this._aspectRatio = ratio;
            var size = this.getImageSize();

            this.setSize(size.width, size.height);

            this._render();

            return this;
        }
    }, {
        key: 'getSize',
        value: function getSize() {
            return {
                width: this._viewport.width,
                height: this._viewport.height
            };
        }
    }, {
        key: 'getImageSize',
        value: function getImageSize() {
            var size = computeRotatedSize(this._image.width, this._image.height, this._transform.rotate - this._transform.rotate % (Math.PI / 2));

            return {
                width: size[0],
                height: size[1]
            };
        }
    }, {
        key: 'rotateAspect',
        value: function rotateAspect() {
            this.setSize(this._viewport.height, this._viewport.width, false);

            return this;
        }
    }, {
        key: 'loadImage',
        value: function loadImage(image) {
            this._image = image;
            this._preview.style.backgroundImage = 'url("' + image.src + '")';
        }
    }, {
        key: 'save',
        value: function save(callback) {
            var quality = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

            if (!this._image) {
                throw 'No image loaded';
            }

            var size = this._viewport,
                c = createCanvas(size.width, size.height),
                ctx = c.getContext('2d'),
                transform = this._computeMatrix(),
                image = this._image;

            ctx.setTransform.apply(ctx, matrix.toTransformArray(matrix.fromTranslate(size.width / 2, size.height / 2)));
            ctx.save();
            ctx.transform.apply(ctx, matrix.toTransformArray(transform));
            ctx.drawImage(image, 0, 0, image.width, image.height, -image.width / 2, -image.height / 2, image.width, image.height);
            ctx.restore();

            var mimetype = 'image/jpeg';

            if (image.src && (image.src.indexOf('data:image/png') === 0 || image.src.match(/.png$/i))) {
                mimetype = 'image/png';
            }

            c.toBlob(callback, mimetype, quality);

            return this;
        }
    }, {
        key: '_fitImage',
        value: function _fitImage() {
            var transform = this._transform,
                viewport = this._viewport,
                image = this._image,
                w = image.width,
                h$$1 = image.height;

            // Ruota il viewport per calcolare il bbox
            var size = computeRotatedSize(viewport.width, viewport.height, transform.rotate).map(Math.round),

            // Calcola quanto l'immagine ruotata è più grande del viewport
            scale = Math.max(transform.scale[0], 1 / Math.min(getScale(w, h$$1, size[0], size[1]), 1)),
                imageSize = [w * scale, h$$1 * scale],
                delta = [(imageSize[0] - size[0]) / 2 / scale, (imageSize[1] - size[1]) / 2 / scale];

            transform.scale[0] = transform.scale[1] = scale;
            transform.translate[0] = clamp(transform.translate[0], -delta[0], delta[0]);
            transform.translate[1] = clamp(transform.translate[1], -delta[1], delta[1]);
        }
    }, {
        key: 'reset',
        value: function reset() {
            resetTransform(this._transform);
            resetSelection(this._selection);

            if (this._image) {
                this.setSize(this._image.width, this._image.height);

                this._onResize();
            }

            return this;
        }
    }, {
        key: 'setTranslate',
        value: function setTranslate(x, y) {
            var render$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var imageScale = getScale(this._canvas.width, this._canvas.height, this._viewport.width, this._viewport.height),
                translate = rotatePoint(x / imageScale, y / imageScale, -this._transform.rotate);

            this._transform.translate[0] = translate[0];
            this._transform.translate[1] = translate[1];

            render$$1 && this._render();

            return this;
        }
    }, {
        key: 'translate',
        value: function translate(x, y) {
            var render$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var imageScale = getScale(this._canvas.width, this._canvas.height, this._viewport.width, this._viewport.height),
                translate = rotatePoint(x / imageScale, y / imageScale, -this._transform.rotate);

            this._transform.translate[0] += translate[0];
            this._transform.translate[1] += translate[1];

            render$$1 && this._render();

            return this;
        }
    }, {
        key: 'setRotate',
        value: function setRotate(deg) {
            this._transform.rotate = deg * RAD;
            this.setAspectRatio(this._aspectRatio);

            return this;
        }
    }, {
        key: 'crop',
        value: function crop() {
            var viewport = this._viewport;
            var selection = this._selection;
            var vw = viewport.width * selection.width;
            var vh = viewport.height * selection.height;
            var vl = (viewport.width - vw) / 2 - selection.left * viewport.width;
            var vt = (viewport.height - vh) / 2 - selection.top * viewport.height;
            var translate = rotatePoint(vl, vt, -this._transform.rotate);

            this._transform.translate[0] += translate[0];
            this._transform.translate[1] += translate[1];

            this._viewport.width = Math.min(vw, this._image.width);
            this._viewport.height = Math.min(vh, this._image.height);

            this._aspectRatio && preserveAspect(this._viewport, this._image, this._aspectRatio);

            resetSelection(selection);
            this._onResize();

            return this;
        }
    }, {
        key: '_computeMatrix',
        value: function _computeMatrix() {
            this._fitImage();

            var transform = this._transform,
                t = matrix.fromTranslate.apply(matrix, transform.translate),
                r = matrix.fromRotateAround(transform.rotate, -transform.translate[0], -transform.translate[1]),
                s = matrix.fromScale.apply(matrix, transform.scale),
                m = void 0;

            m = matrix.multiply(s, t);
            m = matrix.multiply(m, r);

            return m;
        }
    }, {
        key: 'getTransform',
        value: function getTransform() {
            return matrix.toTransformArray(this._computeMatrix());
        }
    }, {
        key: 'getTransformInfo',
        value: function getTransformInfo() {
            var t = this._transform,
                v = this._viewport,
                i = this._image,
                size = computeRotatedSize(i.width, i.height, t.rotate),
                translate = rotatePoint(t.translate[0], t.translate[1], t.rotate);

            return {
                rotate: t.rotate / RAD,
                scale: t.scale,
                crop: [(size[0] - v.width) / 2 - translate[0], (size[1] - v.height) / 2 - translate[1], v.width, v.height].map(Math.round)
            };
        }
    }, {
        key: 'setSelection',
        value: function setSelection(top, left, width, height) {
            this._selection.top = top;
            this._selection.left = left;
            this._selection.width = width;
            this._selection.height = height;

            if (width > 1 || height > 1) {
                var _transform$translate = this._transform.translate,
                    tx = _transform$translate[0],
                    ty = _transform$translate[1];


                var _vw = this._viewport.width;
                var _vh = this._viewport.height;

                this.crop();

                this._transform.translate = [tx, ty];
                this._viewport.width = _vw;
                this._viewport.height = _vh;

                this._selection.top = top;
                this._selection.left = left;
                this._selection.width = width;
                this._selection.height = height;

                return this;
            }

            this._render();

            return this;
        }
    }, {
        key: 'getScale',
        value: function getScale$$1() {
            var image = this._image,
                viewport = this._viewport;
            // Calcolo un fattore di zoom per far sì che l'immagine sia sempre abbastanza grande da essere lavorabile
            var zoomFactor = MIN_SIZE / Math.min(image.width, MIN_SIZE) * (100 / Math.min(image.height, 100));

            // VIEWPORT_PERCENTAGE lo usiamo per crearci un margine fittizio tra container e wrapper
            return getScale(clamp(image.width, zoomFactor * image.width, this._wrapper.offsetWidth * VIEWPORT_PERCENTAGE), clamp(image.height, zoomFactor * image.height, this._wrapper.offsetHeight * VIEWPORT_PERCENTAGE), viewport.width, viewport.height);
        }
    }, {
        key: '_onResize',
        value: function _onResize() {
            var render$$1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (!this._image) {
                return;
            }

            var viewport = this._viewport,
                image = this._image;

            var scale = getScale(this._wrapper.offsetWidth * VIEWPORT_PERCENTAGE, this._wrapper.offsetHeight * VIEWPORT_PERCENTAGE, viewport.width, viewport.height);

            var nextWidth = Math.floor(viewport.width * scale);
            var nextHeight = Math.floor(viewport.height * scale);

            this._preview.style.marginTop = '-' + image.height / 2 + 'px';
            this._preview.style.marginLeft = '-' + image.width / 2 + 'px';
            this._preview.style.width = image.width + 'px';
            this._preview.style.height = image.height + 'px';

            if (this._canvas.width !== nextWidth || this._canvas.height !== nextHeight) {
                this._canvas.height = nextHeight - 1; //Safari bugfix
                this._canvas.width = nextWidth;
                this._canvas.height = nextHeight;
            }

            render$$1 && this._render();
        }
    }, {
        key: 'canMove',
        value: function canMove() {
            var scale = this.getScale();

            if (this._transform.rotate / RAD % 180 === 0) {
                return Math.abs(this._image.height * scale - this._canvas.height) > 1 || Math.abs(this._canvas.width - this._image.width * scale) > 1;
            } else {
                return Math.abs(this._image.height * scale - this._canvas.width) > 1 || Math.abs(this._canvas.height - this._image.width * scale) > 1;
            }
        }
    }, {
        key: '_render',
        value: function _render() {
            var ctx = this._context,
                canvas = this._canvas,
                image = this._image,
                selection = this._selection,
                viewport = this._viewport,
                transform = this._computeMatrix();

            if (!image) {
                return;
            }

            var imageScale = getScale(canvas.width, canvas.height, viewport.width, viewport.height);

            clearContext(ctx);
            transform = matrix.toTransformArray(matrix.multiply(matrix.fromScale(imageScale), transform));

            var top = canvas.height * selection.top,
                left = canvas.width * selection.left,
                height = canvas.height * selection.height,
                width = canvas.width * selection.width;

            ctx.save();
            ctx.beginPath();
            ctx.rect(left, top, width, height);
            ctx.fill();
            ctx.clip();

            ctx.setTransform.apply(ctx, matrix.toTransformArray(matrix.fromTranslate(canvas.width / 2, canvas.height / 2)));

            ctx.save();
            ctx.transform.apply(ctx, transform);
            ctx.drawImage(image, 0, 0, image.width, image.height, -image.width / 2, -image.height / 2, image.width, image.height);
            ctx.restore();

            ctx.restore();

            cssTransform(this._preview, 'matrix(' + transform.join(',') + ')');
        }
    }]);

    return Editor;
}();

/** @jsx h */

var Button = function Button(_ref) {
    var onClick = _ref.onClick,
        children = _ref.children,
        disabled = _ref.disabled,
        secodary = _ref.secodary,
        primary = _ref.primary,
        icon = _ref.icon,
        link = _ref.link;
    return h(
        'div',
        {
            className: 'lie-button\n            ' + (secodary ? ' lie-button--default' : '') + '\n            ' + (disabled ? ' lie-button--disabled' : '') + '\n            ' + (primary ? ' lie-button--primary' : '') + '\n            ' + (icon ? ' lie-button--icon' : '') + '\n            ' + (link ? ' lie-button--link' : ''),
            onClick: onClick
        },
        children
    );
};

var TranslationProvider = function (_Component) {
    _inherits(TranslationProvider, _Component);

    function TranslationProvider() {
        _classCallCheck(this, TranslationProvider);

        return _possibleConstructorReturn(this, (TranslationProvider.__proto__ || Object.getPrototypeOf(TranslationProvider)).apply(this, arguments));
    }

    _createClass(TranslationProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return { translations: this.props.translations };
        }
    }, {
        key: 'render',
        value: function render$$1() {
            return this.props.children[0];
        }
    }]);

    return TranslationProvider;
}(Component);

var Translate = function Translate(_ref, _ref2) {
    var children = _ref.children;
    var translations = _ref2.translations;
    return translations[children[0]];
};

/** @jsx h */

var RAW_MODE = 'raw';
var DATA_MODE = 'data';

var getMode = function getMode(mode) {
    return mode.toLowerCase() === RAW_MODE ? RAW_MODE : DATA_MODE;
};

var Save = function Save(_ref) {
    var mode = _ref.mode;
    return h(
        StoreConnector,
        null,
        function (_ref2) {
            var dispatch = _ref2.dispatch;
            return h(
                Button,
                { primary: true, onClick: function onClick() {
                        return dispatch(saveAction, getMode(mode));
                    } },
                h(
                    Translate,
                    null,
                    'save'
                )
            );
        }
    );
};

/** @jsx h */

var DragHint = function DragHint(_ref) {
    var visible = _ref.visible,
        children = _ref.children;
    return h(
        'div',
        {
            className: 'lie__hint\n        ' + (visible ? '' : ' lie__hint--visible')
        },
        h(
            'svg',
            {
                xmlns: 'http://www.w3.org/2000/svg',
                viewBox: '0 0 20 20',
                className: 'lie__icon'
            },
            h('path', {
                className: 'lie__hint-icon',
                id: 'move',
                d: 'M10 0L5.625 4.375H8.75V8.75H4.375V5.625L0 10l4.375 4.375V11.25H8.75v4.375H5.625L10 20l4.375-4.375H11.25V11.25h4.375v3.125L20 10l-4.375-4.375V8.75H11.25V4.375h3.125z'
            })
        ),
        children
    );
};

function getEventCoords(e) {
    return {
        x: e.clientX || e.touches && e.touches[0] && e.touches[0].pageX || 0,
        y: e.clientY || e.touches && e.touches[0] && e.touches[0].pageY || 0
    };
}

function isHintVisible(editor, translated$$1) {
    return !editor || translated$$1 || !editor.canMove();
}

function reduceState(state) {
    return {
        saveRequested: saveRequested(state),
        restoreRequested: restoreRequested(state),
        rotate: rotate(state),
        translate: translate(state),
        aspect: aspect(state),
        scale: scale(state),
        translated: translated(state)
    };
}

var Editor$1 = function (_Component) {
    _inherits(Editor$$1, _Component);

    function Editor$$1() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Editor$$1);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Editor$$1.__proto__ || Object.getPrototypeOf(Editor$$1)).call.apply(_ref, [this].concat(args))), _this), _this.state = reduceState(), _this.setup = function () {
            _this.editor = new Editor(_this.editorContainer, _this.base);

            _this.editor.loadImage(_this.props.img);

            _this.deregisterStore = _this.context.store.onChange(reduceState, _this.onStateChange.bind(_this));

            if (_this.props.ratio) {
                _this.computedAspectRatio = calculateAspectRatio(_this.props.ratio);
                _this.editor.setAspectRatio(_this.computedAspectRatio);
                _this.forceAspectRatio();
            }
            window.addEventListener('resize', _this.onResize);

            _this.context.store.dispatch(restoreAction);
        }, _this.onResize = function () {
            _this.editor._onResize();
        }, _this.onStateChange = function (nextState) {
            var _this2 = _this,
                editor = _this2.editor,
                state = _this2.state;


            if (nextState.rotate !== state.rotate && !state.aspect && !_this.computedAspectRatio) {
                editor.rotateAspect();
            }

            if (nextState.aspect !== state.aspect) {
                editor.setAspectRatio(nextState.aspect);
            }

            if (nextState.rotate !== state.rotate) {
                editor.setRotate(nextState.rotate);
            }

            if (nextState.scale !== state.scale || nextState.aspect !== state.aspect || nextState.rotate !== state.rotate) {
                var _scale = 1 + nextState.scale / 100;
                var size = editor.getImageSize();
                editor.setSize(size.width / _scale, size.height / _scale);
            }

            if (state.translate && nextState.translate && nextState.translate !== state.translate) {
                editor.translate(nextState.translate.x - state.translate.x, nextState.translate.y - state.translate.y);
            }

            if (nextState.saveRequested !== state.saveRequested && nextState.saveRequested) {
                if (nextState.saveRequested.mode === RAW_MODE) {
                    editor.save(_this.saveData);
                } else {
                    _this.saveData(editor.getTransformInfo());
                }
            }

            if (nextState.restoreRequested !== state.restoreRequested && nextState.restoreRequested) {
                editor.reset();

                if (_this.computedAspectRatio) {
                    _this.forceAspectRatio();
                }
            }

            _this.setState(nextState);
        }, _this.saveData = function (data) {
            _this.context.store.dispatch(saveDoneAction, data);
        }, _this.updateTranslation = function (e) {
            _this.context.store.dispatch(translateAction, e ? getEventCoords(e) : null);
        }, _this.onDragStart = function (e) {
            e.preventDefault();
            addClass(_this.editorContainer, 'lie__canvas--dragging', true);
            document.addEventListener('mousemove', _this.updateTranslation);
            document.addEventListener('touchmove', _this.updateTranslation);
            document.addEventListener('mouseup', _this.onDragEnd);
            document.addEventListener('touchend', _this.onDragEnd);
        }, _this.onDragEnd = function (e) {
            removeClass(_this.editorContainer, 'lie__canvas--dragging', false);
            document.removeEventListener('mousemove', _this.updateTranslation);
            document.removeEventListener('touchmove', _this.updateTranslation);
            document.removeEventListener('mouseup', _this.onDragEnd);
            document.removeEventListener('touchend', _this.onDragEnd);

            _this.updateTranslation();
        }, _this.getViewportSize = function () {
            var _this$editorContainer = _this.editorContainer.getBoundingClientRect(),
                width = _this$editorContainer.width,
                height = _this$editorContainer.height;

            return {
                width: width,
                height: height
            };
        }, _this.setEditorContainer = function (el) {
            _this.editorContainer = el;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Editor$$1, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            //Uso raf per aspettare che la UI sia completa per prendermi le dimensioni giuste
            requestAnimationFrame(this.setup);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.onResize);
            this.deregisterStore();
        }
    }, {
        key: 'forceAspectRatio',
        value: function forceAspectRatio(aspect$$1) {
            var size = this.editor.getImageSize();
            var originalAspect = size.width / size.height;
            var targetAspect = aspect$$1 || this.computedAspectRatio || originalAspect;
            var newWidth = originalAspect > targetAspect ? size.height * targetAspect : size.width;
            var newHeight = newWidth / targetAspect;

            this.editor.setSize(newWidth, newHeight);
        }
    }, {
        key: 'render',
        value: function render$$1() {
            return h(
                'div',
                { className: 'lie__body' },
                h(
                    'div',
                    { className: 'lie__editor' },
                    h(
                        'div',
                        {
                            ref: this.setEditorContainer,
                            className: 'lie__canvas',
                            onMouseDown: this.onDragStart,
                            onTouchStart: this.onDragStart
                        },
                        h(
                            DragHint,
                            {
                                visible: isHintVisible(this.editor, this.state.translated)
                            },
                            h(
                                Translate,
                                null,
                                'drag'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Editor$$1;
}(Component);

/** @jsx h */

var Rotate = function Rotate() {
    return h(
        StoreConnector,
        null,
        function (_ref) {
            var dispatch = _ref.dispatch;
            return h(
                Button,
                { icon: true, link: true, onClick: function onClick() {
                        return dispatch(rotate90Action, -90);
                    } },
                h(
                    'svg',
                    {
                        xmlns: 'http://www.w3.org/2000/svg',
                        viewBox: '0 0 22 20',
                        className: 'lie-button__icon lie-button__icon--rotate'
                    },
                    h(
                        'g',
                        { fill: 'none', stroke: '#000', 'stroke-width': '1.4', id: 'rotate' },
                        h('path', { d: 'M2.6 12.516c.958 3.864 4.511 6.734 8.748 6.734 4.972 0 9.002-3.951 9.002-8.825 0-4.874-4.03-8.825-9.002-8.825-3.753 0-6.97 2.251-8.32 5.451' }),
                        h('path', {
                            'stroke-linejoin': 'miter',
                            'stroke-linecap': 'square',
                            d: 'M7.9 5.837L2.931 7.17 1.6 2.2'
                        })
                    )
                ),
                h(
                    'span',
                    null,
                    h(
                        Translate,
                        null,
                        'rotate'
                    )
                )
            );
        }
    );
};

/** @jsx h */

var reduceState$1 = function reduceState(state) {
    return { changed: changed(state) };
};

var Restore = function Restore() {
    return h(
        StoreConnector,
        { reduceState: reduceState$1 },
        function (_ref) {
            var changed$$1 = _ref.state.changed,
                dispatch = _ref.dispatch;
            return h(
                Button,
                {
                    secondary: true,
                    disabled: !changed$$1,
                    onClick: changed$$1 ? function () {
                        dispatch(restoreAction);
                    } : null
                },
                h(
                    Translate,
                    null,
                    'restore'
                )
            );
        }
    );
};

/** @jsx h */

var Aspect = function Aspect(_ref, context) {
    var aspect = _ref.aspect;
    return h(
        Button,
        {
            icon: true,
            link: true,
            onClick: function onClick() {
                return context.store.dispatch(aspectAction, calculateAspectRatio(aspect));
            }
        },
        h('i', {
            className: 'lie-button__icon lie-button__icon--ratio',
            'data-ratio': aspect
        }),
        h(
            'span',
            null,
            h(
                Translate,
                null,
                'adapt'
            )
        )
    );
};

function isLTR() {
    return document.dir !== 'rtl';
}

function getRelativeX(rect, clientX) {
    if (clientX > rect.right) {
        return isLTR() ? rect.width : 0;
    }
    if (clientX <= rect.left) {
        return isLTR() ? 0 : rect.width;
    }

    return isLTR() ? clientX - rect.left : rect.right - clientX;
}

function getZoom(rect, clientX) {
    var x = getRelativeX(rect, clientX);

    return Math.floor(x / rect.width * 100);
}

function reduceState$2(state) {
    return {
        scale: scale(state)
    };
}

function getEvtXPosition(evt) {
    return evt.clientX || evt.touches && evt.touches[0] && evt.touches[0].pageX;
}

var Zoom = function (_Component) {
    _inherits(Zoom, _Component);

    function Zoom() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Zoom);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Zoom.__proto__ || Object.getPrototypeOf(Zoom)).call.apply(_ref, [this].concat(args))), _this), _this.state = reduceState$2(), _this.onStateChange = function (nextState) {
            if (nextState !== _this.state) {
                _this.setState(nextState);
            }
        }, _this.updateScale = function (evt) {
            _this.context.store.dispatch(scaleAction, getZoom(_this.track.getBoundingClientRect(), getEvtXPosition(evt)));
        }, _this.onDragStart = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            _this.updateScale(evt);
            _this.removeMoveListener = addEvent(document, 'touchmove mousemove', _this.updateScale);
            _this.removeDragEndListener = addEvent(document, 'mouseup touchend', _this.onDragEnd);
        }, _this.onDragEnd = function () {
            _this.removeMoveListener();
            _this.removeDragEndListener();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Zoom, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.deregister = this.context.store.onChange(reduceState$2, this.onStateChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.deregister();
        }
    }, {
        key: 'render',
        value: function render$$1() {
            var _this2 = this,
                _ref2;

            return h(
                'div',
                { className: 'lie-zoom' },
                h(
                    'i',
                    {
                        className: 'lie-zoom__icon ' + (this.state.scale === 0 ? 'lie-zoom__icon--disabled' : '')
                    },
                    h(
                        'svg',
                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 20 20' },
                        h('path', {
                            id: 'picture',
                            className: 'lie-zoom__icon-path',
                            d: 'M0,17.5H20V2.5H0ZM1.25,3.75h17.5V15L15,10l-3.75,3.75-5-6.25-5,7Zm13.13,5a1.88,1.88,0,1,1,1.88-1.87A1.87,1.87,0,0,1,14.38,8.75Z'
                        })
                    )
                ),
                h(
                    'div',
                    {
                        className: 'lie-zoom__track',
                        onMouseDown: this.onDragStart,
                        onTouchStart: this.onDragStart,
                        ref: function ref(el) {
                            _this2.track = el;
                        }
                    },
                    h('div', {
                        className: 'lie-zoom__progress',
                        style: { width: this.state.scale + '%' }
                    }),
                    h('div', {
                        className: 'lie-zoom__handle',
                        style: (_ref2 = {}, _ref2[isLTR() ? 'left' : 'right'] = this.state.scale + '%', _ref2)
                    })
                ),
                h(
                    'i',
                    {
                        className: 'lie-zoom__icon ' + (this.state.scale === 100 ? 'lie-zoom__icon--disabled' : '')
                    },
                    h(
                        'svg',
                        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 20 20' },
                        h('path', {
                            id: 'picture',
                            className: 'lie-zoom__icon-path',
                            d: 'M0,17.5H20V2.5H0ZM1.25,3.75h17.5V15L15,10l-3.75,3.75-5-6.25-5,7Zm13.13,5a1.88,1.88,0,1,1,1.88-1.87A1.87,1.87,0,0,1,14.38,8.75Z'
                        })
                    )
                )
            );
        }
    }]);

    return Zoom;
}(Component);

/** @jsx h */

var Toolbar = function Toolbar(_ref) {
    var mode = _ref.mode,
        scale = _ref.scale,
        suggestedaspectratio = _ref.suggestedaspectratio,
        ratio = _ref.ratio;

    return h(
        'div',
        { className: 'lie__toolbar' },
        h(
            'div',
            { className: 'lie__toolbar-left' },
            h(Rotate, null),
            !ratio && suggestedaspectratio ? h(Aspect, { aspect: suggestedaspectratio }) : null,
            h(Zoom, null)
        ),
        h(
            'div',
            { className: 'lie__toolbar-right' },
            h(Restore, null),
            h(Save, { mode: mode })
        )
    );
};

var ImageEditorBootstrap = function (_Component) {
    _inherits(ImageEditorBootstrap, _Component);

    function ImageEditorBootstrap() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ImageEditorBootstrap);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageEditorBootstrap.__proto__ || Object.getPrototypeOf(ImageEditorBootstrap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            img: null
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ImageEditorBootstrap, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadImage(this.props.imgurl);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ img: null });
            this.loadImage(nextProps.imgurl);
        }
    }, {
        key: 'loadImage',
        value: function loadImage$$1(imgurl) {
            var _this2 = this;

            loadImage(imgurl, function (img) {
                _this2.setState({ img: img });
            });
        }
    }, {
        key: 'render',
        value: function render$$1(props, _ref2) {
            var img = _ref2.img;

            return img ? h(
                'div',
                { 'class': 'lie' },
                h(Editor$1, _extends({}, props, { img: img })),
                h(Toolbar, props)
            ) : h('div', { 'class': 'lie lie--loading' });
        }
    }]);

    return ImageEditorBootstrap;
}(Component);

var defaultTranslations = {
    save: 'Salva',
    restore: 'Ripristina',
    rotate: 'Ruota',
    adapt: 'Adatta',
    drag: 'Trascina per riposizionare'
};

function reduceState$3(state) {
    return {
        saveData: saveData(state),
        saved: saved(state)
    };
}

function preventDefault(evt) {
    evt.preventDefault();
}

var LabsImgEditor = function (_Component) {
    _inherits(LabsImgEditor, _Component);

    function LabsImgEditor() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LabsImgEditor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LabsImgEditor.__proto__ || Object.getPrototypeOf(LabsImgEditor)).call.apply(_ref, [this].concat(args))), _this), _this.store = createStore(), _this.onStateChange = function (nextState) {
            if (!nextState.saved) return;

            _this.props.onSave({
                data: nextState.saveData
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LabsImgEditor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.deregister = this.store.onChange(reduceState$3, this.onStateChange);
            //Prevents page zoom on IOS devices
            document.addEventListener('gesturestart', preventDefault);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.deregister();
            document.removeEventListener('gesturestart', preventDefault);
        }
    }, {
        key: 'save',
        value: function save() {
            this.store.dispatch(saveAction, getMode(this.props.mode));
        }
    }, {
        key: 'render',
        value: function render$$1() {
            return h(
                TranslationProvider,
                {
                    translations: _extends({}, defaultTranslations, removeEmptyStrings(this.props.translations || {}))
                },
                h(
                    StoreProvider,
                    { store: this.store },
                    h(ImageEditorBootstrap, this.props)
                )
            );
        }
    }]);

    return LabsImgEditor;
}(Component);

var LabsImgEditorHandler = function (_Component2) {
    _inherits(LabsImgEditorHandler, _Component2);

    function LabsImgEditorHandler() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, LabsImgEditorHandler);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = LabsImgEditorHandler.__proto__ || Object.getPrototypeOf(LabsImgEditorHandler)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
            open: true
        }, _this2.close = function () {
            _this2.setState({ open: false });
        }, _this2.handleSave = function (_ref3) {
            var data = _ref3.data;

            _this2.props.onSave({
                data: data,
                closeEditor: _this2.close
            });
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    _createClass(LabsImgEditorHandler, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.mountHook && this.props.mountHook(this);
        }
    }, {
        key: 'render',
        value: function render$$1() {
            if (!this.state.open) return null;

            return h(LabsImgEditor, _extends({}, this.props, { onSave: this.handleSave }));
        }
    }]);

    return LabsImgEditorHandler;
}(Component);

var removeEmptyStrings = function removeEmptyStrings(obj) {
    var ret = {};
    Object.keys(obj).forEach(function (k) {
        if (obj[k] !== '') {
            ret[k] = obj[k];
        }
    });
    return ret;
};

/**
 *
 * @param HTMLElement container
 * @param { imgurl, ratio, suggestedaspectratio, mode, translations, onSave } props
 */
function renderImageEditor(container, props) {
    var close = void 0;

    render(h(LabsImgEditorHandler, _extends({}, props, {
        mountHook: function mountHook(component) {
            close = component.close;
        }
    })), container);

    return close;
}

function openImageEditor(props) {
    var container = document.createElement('div');

    document.body.appendChild(container);

    return renderImageEditor(container, props);
}

var support = {
    isSupported: isSupported,
    isLocalTransformSupported: isLocalTransformSupported
};

export { support, renderImageEditor, openImageEditor };
